import api from './api';

export interface WindsorMetricRow {
  connector: string;
  account_id: string;
  account_name: string | null;
  date: string;
  platform: string;
  // Instagram orgânico
  reach: number | null;
  views: number | null;
  accounts_engaged: number | null;
  total_interactions: number | null;
  likes: number | null;
  comments: number | null;
  shares: number | null;
  saves: number | null;
  new_followers: number | null;
  profile_links_taps: number | null;
  // Meta Ads
  spend: number | null;
  impressions: number | null;
  ad_reach: number | null;
  clicks: number | null;
  cpc: number | null;
  cpm: number | null;
  ctr: number | null;
  synced_at: string;
}

export interface WindsorTotals {
  reach: number;
  views: number;
  interactions: number;
  new_followers: number;
  spend: number;
  impressions: number;
  clicks: number;
}

export interface WindsorMetricsResult {
  series: WindsorMetricRow[];
  totals: WindsorTotals;
  dateFrom: string;
  dateTo: string;
}

export interface WindsorSyncLog {
  id: number;
  started_at: string;
  finished_at: string | null;
  status: 'running' | 'success' | 'partial' | 'error';
  connectors_synced: string[] | null;
  records_written: number;
  error_msg: string | null;
  created_at: string;
}

class MarketingWindsorService {
  async getMetrics(
    connector?: string,
    accountId?: string,
    dateFrom?: string,
    dateTo?: string,
  ): Promise<WindsorMetricsResult> {
    const params = new URLSearchParams();
    if (connector) params.set('connector', connector);
    if (accountId) params.set('accountId', accountId);
    if (dateFrom) params.set('dateFrom', dateFrom);
    if (dateTo) params.set('dateTo', dateTo);
    const res = await api.get(`/admin/marketing/windsor/metrics?${params.toString()}`);
    return res.data.data;
  }

  async triggerSync(): Promise<{ records: number; errors: string[] }> {
    const res = await api.post('/admin/marketing/windsor/trigger', {});
    return res.data.data;
  }

  async getSyncLog(): Promise<WindsorSyncLog[]> {
    const res = await api.get('/admin/marketing/windsor/sync-log');
    return res.data.data;
  }
}

export default new MarketingWindsorService();
